module.exports = __webpack_public_path__ + "media/images/es_419/energize_action-4ed05643ff3ade43c982b78068ea8bc6.png";